// extracted by mini-css-extract-plugin
export default {"postCard":"PostCard_postCard__7WGT1"};